(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fishe-faq-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.faqReady === 'true') return;
      root.dataset.faqReady = 'true';
      const input = root.querySelector('[data-faq-search]');
      const filters = [...root.querySelectorAll('[data-faq-filter]')];
      const status = root.querySelector('[data-faq-status]');
      const empty = root.querySelector('[data-faq-empty]');
      const reset = root.querySelector('[data-faq-reset]');
      const expand = root.querySelector('[data-faq-expand]');
      const collapse = root.querySelector('[data-faq-collapse]');
      let activeCategory = 'all';

      const categories = () => [...document.querySelectorAll('[data-faq-category]')];
      const normalize = (value) => value.toLowerCase().replace(/\s+/g, ' ').trim();
      const totalItems = () =>
        categories().reduce((sum, category) => sum + category.querySelectorAll('[data-faq-item]').length, 0);

      const update = () => {
        const query = normalize(input.value);
        let visibleCount = 0;
        const totalCount = totalItems();

        categories().forEach((category) => {
          const categoryMatches = activeCategory === 'all' || category.dataset.faqCategory === activeCategory;
          let categoryCount = 0;

          category.querySelectorAll('[data-faq-item]').forEach((item) => {
            const matches = categoryMatches && (!query || normalize(item.dataset.faqSearch || '').includes(query));
            item.hidden = !matches;
            if (matches) {
              categoryCount += 1;
              visibleCount += 1;
            }
          });

          category.hidden = categoryCount === 0;
        });

        const template = root.dataset.resultsTemplate || '[count] answers';
        status.textContent = template
          .replace('[count]', visibleCount)
          .replace('[total]', totalCount);
        empty.hidden = visibleCount !== 0;
      };

      input.addEventListener('input', update);

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          activeCategory = button.dataset.faqFilter;
          filters.forEach((filter) => {
            const selected = filter === button;
            filter.classList.toggle('is-active', selected);
            filter.setAttribute('aria-pressed', String(selected));
          });
          update();
        });
      });

      reset.addEventListener('click', () => {
        input.value = '';
        activeCategory = 'all';
        filters.forEach((filter) => {
          const selected = filter.dataset.faqFilter === 'all';
          filter.classList.toggle('is-active', selected);
          filter.setAttribute('aria-pressed', String(selected));
        });
        update();
        input.focus();
      });

      expand.addEventListener('click', () => {
        categories().forEach((category) => {
          if (!category.hidden) {
            category.querySelectorAll('details[data-faq-item]:not([hidden])').forEach((item) => {
              item.open = true;
            });
          }
        });
      });

      collapse.addEventListener('click', () => {
        categories().forEach((category) => {
          category.querySelectorAll('details[data-faq-item]').forEach((item) => {
            item.open = false;
          });
        });
      });

      update();
    };

    const setupAll = () => {
      document.querySelectorAll('[data-fishe-faq-controller]').forEach(setup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll, { once: true });
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', setupAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
